export default __webpack_public_path__ + "static/media/fireworksBackground.c7c0c14e.png";